import React, {useState} from 'react';
import {GitMerge, ArrowRight} from 'lucide-react';
import {Button} from './ui/Button';
import {Field} from './ui/Input';

interface LoginProps {
    onLogin: (email: string, password: string) => void;
    onSwitchToRegister: () => void;
    error: string | null;
}

export const Login: React.FC<LoginProps> = ({onLogin, onSwitchToRegister, error}) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // TODO: add validation
        onLogin(email, password);
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-[#f4f1e6] p-4 text-[#0a0a0a]">
            <div className="w-full max-w-md">
                <div className="mb-8 text-center">
                    <div className="mb-4 inline-flex items-center gap-3">
                        <div className="nb-shadow-sm rounded-2xl border-2 border-[#0a0a0a] bg-[#22c55e] p-3">
                            <GitMerge size={32} className="text-[#0a0a0a]" strokeWidth={2.6}/>
                        </div>
                        <h1 className="text-4xl font-extrabold tracking-tight">ReviewMe</h1>
                    </div>
                    <p className="text-lg font-medium text-[#4f4f48]">Sign in to your dashboard</p>
                </div>

                <div className="nb-shadow-lg rounded-2xl border-2 border-[#0a0a0a] bg-white p-8">
                    {error && (
                        <div className="mb-5 rounded-xl border-2 border-[#0a0a0a] bg-[#fecdd3] p-3 text-sm font-bold text-[#be123c]">
                            {error}
                        </div>
                    )}
                    <form onSubmit={handleSubmit} className="space-y-5">
                        <Field
                            label="Email"
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="you@company.com"
                        />
                        <Field
                            label="Password"
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••••"
                        />
                        <Button type="submit" className="mt-2 w-full text-base">
                            Log In <ArrowRight size={20} strokeWidth={3}/>
                        </Button>
                    </form>

                    <div className="mt-6 text-center">
                        <p className="font-medium text-[#4f4f48]">
                            Don&apos;t have an account?{' '}
                            <button onClick={onSwitchToRegister} className="font-extrabold text-[#15803d] hover:underline">
                                Register
                            </button>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
